<template>
	<div>
		<b-alert show variant="primary">
			Puede generar un token de acceso para cada aplicación que necesite
			consumir el API de shuttlecentral. El nombre de una clave, debe
			contener <strong> por lo menos 4 caracteres. </strong>
		</b-alert>
		<div class="mb-4">
			<b-form inline>
				<label class="sr-only" for="inline-form-input-name"
					>Nombre</label
				>
				<b-form-input
					id="inline-form-input-name"
					class="mb-2 mr-sm-2 mb-sm-0"
					placeholder="Nombre"
					v-model="reg.name"
				></b-form-input>

				<b-input-group class="mb-2 mr-sm-2 mb-sm-0">
					<b-form-input
						placeholder=""
						disabled
						v-model="reg.key"
					></b-form-input>
				</b-input-group>

				<b-button
					v-if="$hasPermission('pointOfSale.key.add')"
					variant="primary"
					@click.prevent="save()"
					:disabled="reg.name.length < 4 || saving"
					>Registrar Key</b-button
				>
			</b-form>
		</div>

		<FormGroupBox title="Llaves API">
			<b-form-row>
				<b-form-group class="col-2 ml-auto" label="POS ID">
					<b-form-input
						type="text"
						size="sm"
						v-model="this.conf.idpointsale"
						required
						disabled
					/>
				</b-form-group>
			</b-form-row>

			<h6 class="mt-1">Claves registradas</h6>

			<div class="table-responsive">
				<table class="table table-striped table-sm">
					<thead>
						<tr>
							<th scope="col">Nombre</th>
							<th scope="col">Key</th>
							<th scope="col">Acciones</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in items" :key="index">
							<td>{{ item.name }}</td>
							<td>
								<span v-if="item.show">{{ item.key }}</span>
								<span v-else>****************</span>
							</td>
							<td>
								<b-button
									type="button"
									size="sm"
									:disabled="!$hasPermission('pointOfSale.key.show')"
									class="mr-1"
									variant="info"
									@click.prevent="toogle(index)"
								>
									<span v-if="!item.show">Ver</span>
									<span icon="eye-slash" v-else>Ocultar</span>
								</b-button>

								<b-button
									type="button"
									v-if="$hasPermission('pointOfSale.key.delete')"
									size="sm"
									class="mr-1"
									variant="danger"
									@click.prevent="deleteKey(index)"
									:disabled="item.name === 'PointOfSales'"
								>
									<md-icon icon="delete" />
								</b-button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</FormGroupBox>
	</div>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";

export default {
	components: { FormGroupBox },
	props: ["conf"],
	data() {
		return {
			items: [],
			reg: {
				name: "",
				key: "",
				show: false
			},
			saving: false
		};
	},
	watch: {
		"conf.keys": function() {
			const resp = this.unLink(this.conf.keys);
			if (this.items.length <= 0) {
				resp.forEach(element => {
					this.items.push(Object.assign(element, { show: false }));
				});
			}
		}
	},
	methods: {
		toogle(index) {
			this.items[index].show = !this.items[index].show;
		},
		reset() {
			this.reg.name = "";
		},
		save() {
			this.reg.key = this.generateKey(10);
			this.saving = true;
			this.$root.api
				.post(
					`/point-of-sales/${this.conf.idpointsale}/api-keys`,
					Object.assign(this.reg, {
						pointOfSaleId: this.conf.idpointsale
					})
				)
				.then(r => {
					const rg = Object.assign(this.reg, { id: r.data.id });
					this.items.push(
						this.unLink(rg)
					);
					setTimeout(() => {
						this.reset();
					}, 100);
				})
				.catch(this.$root.handleRequestError)
				.finally(() => {
					this.saving = false;
				});
		},
		generateKey() {
			const key1 = (Math.random() + 1).toString(36).substring(2);
			const key2 = (Math.random() + 1).toString(36).substring(3);
			return key1 + key2;
		},
		unLink(data) {
			return JSON.parse(JSON.stringify(Object.assign(data)));
		},
		deleteKey(index) {
			const key = this.items[index];
			this.$root.api
				.delete(
					`/point-of-sales/${this.conf.idpointsale}/api-keys/${key.id}`
				)
				.then(() => {
					setTimeout(() => {
						this.items.splice(index, 1);
					}, 100);
				})
				.catch(this.$root.handleRequestError);
		}
	},
	mounted() {}
};
</script>
